<template>
  <div>
    <!-- Toggle button -->
    <button class="block" @click="toggleSidebarMenu">
      <Icon name="hamburger" class="h-7 w-7 text-yka-blue font-bold" />
    </button>

    <!-- Sidebar -->
    <nav
      class="sidebar-collapse h-full w-full top-0 fixed left-0 menu-font"
      :class="{ open: showSidebarMenu }"
    >
      <div
        class="absolute bg-white top-0 left-0 w-full h-full opacity-95"
      ></div>

      <div
        class="absolute w-full h-full mx-auto px-0 py-20 sm:p-20 overflow-y-auto"
      >
        <!-- Close button -->
        <button
          class="block absolute right-10 top-10 z-20"
          @click="toggleSidebarMenu"
        >
          <Icon name="close" class="h-7 w-7" />
        </button>

        <!-- Menu list -->
        <ul
          class="menu flex flex-col items-start space-y-2"
          v-if="settings.menus?.primary"
        >
          <li
            v-for="item in settings.menus.primary"
            :key="item.id"
            class="w-full"
          >
            <!-- Main NavLink -->
            <component
              :is="item.tag"
              :to="item.path"
              :href="item.path"
              :target="item.tag === 'a' ? '_blank' : undefined"
              class="block w-full text-left text-yka-blue text-lg font-bold py-2 px-4 rounded hover:bg-yka-blue/10 transition-colors"
              @click="handleClick"
            >
              {{ item.title }}
            </component>

            <!-- Children (if any) -->
            <ul v-if="item.children" class="ml-4 mt-1 pl-2 space-y-1">
              <li v-for="child in item.children" :key="child.id">
                <component
                  :is="child.tag"
                  :to="child.path"
                  :href="child.path"
                  :target="child.tag === 'a' ? '_blank' : undefined"
                  class="block w-full text-left text-yka-blue text-base py-1 px-4 rounded hover:bg-yka-blue/10 transition-colors"
                  @click="handleClick"
                >
                  {{ child.title }}
                </component>
              </li>
            </ul>
          </li>
        </ul>

        <FooterIcons class="mt-8" />
      </div>
    </nav>
  </div>
</template>

<script>
import Icon from "@/components/Icons.vue";
import FooterIcons from "@/components/footer/FooterIcons.vue";

import Settings from "@/lib/Settings";
import { ref } from "vue";

export default {
  name: "SideMenu",
  components: {
    Icon,
    FooterIcons,
  },
  setup() {
    const showSidebarMenu = ref(false);
    const { settings } = Settings();

    const toggleSidebarMenu = () => {
      showSidebarMenu.value = !showSidebarMenu.value;
    };

    const handleClick = () => {
      showSidebarMenu.value = false;
    };

    return {
      settings,
      showSidebarMenu,
      toggleSidebarMenu,
      handleClick,
    };
  },
};
</script>

<style scoped>
.sidebar-collapse {
  @apply z-50;
  transform: translateX(-100%);
  transition: all ease 0.25s;
}

.open.sidebar-collapse {
  transform: translateX(0);
}

nav ul.menu li {
  @apply mb-1;
}

nav ul.menu a[href],
nav ul.menu a {
  @apply block;
}
</style>
